<!-- 任务列表任务功能区 -->
<template>
    <div class="function-operate" v-if="!task.isCanceling">
        <div ref="optionOperate" v-if="task.status!=2">
            <div v-if="task.lowerType!=105" class="option-operate">
                <div>
                    <!-- 启动任务 -->
                    <div class="operate-menu-btn task-operate-play" v-if="task.status==0" @click.stop="updateItem(1)"></div>
                    <!-- 停止任务 -->
                    <div class="operate-menu-btn" :class="(task.type==2&&task.branchType=='realtime')?'task-operate-pause':'task-operate-stop'" v-else @click.stop="updateItem(0)"></div>
                </div>
                <!-- 功能列表 -->
                <div class="operate-menu-btn task-operate-menu" @click.stop="changeOptionMenu(true,$event)" v-if="task.status!=1||(task.type==2&&task.branchType=='realtime')">
                    <div class="operate-menu" ref="operateMenu" v-show="isOpenMenu" v-clickoutside="changeOptionMenu">
                        <!-- 点击查看日志 -->
                        <div class="operate-menu-item" @click.stop="openPopup(1)" v-if="!(task.type==2&&task.branchType=='realtime'&&task.runCount==0)">
                            <div class="icon-util remote-task operate-icon-position"></div>
                            <div class="operate-menu-name">{{$t('language.popup.taskListPopup.viewLogs')}}</div>
                        </div>
                        <!-- 还原 -->
                        <div v-if="task.type==6&&task.lastLog" class="operate-menu-item" @click.stop="openPopup(4)">
                            <div class="icon-util backup-restore-icon operate-icon-position"></div>
                            <div class="operate-menu-name">{{$t('language.cloudExploer.restore')}}</div>
                        </div>
                        <!-- 点击查看版本 -->
                        <div v-if="task.type==6&&task.lastLog" class="operate-menu-item" @click.stop="openPopup(5)">
                            <div class="icon-util backup-version-icon operate-icon-position"></div>
                            <div class="operate-menu-name">{{$t('language.cloudBackup.versions')}}</div>
                        </div>
                        <!-- 点击查看设置 -->
                        <div v-if="task.lowerType!=105" class="operate-menu-item" @click.stop="openPopup(2)">
                            <div class="icon-util properties operate-icon-position"></div>
                            <div class="operate-menu-name">{{$t('language.common.options')}}</div>
                        </div>
                        <!-- 点击删除任务 -->
                        <div class="operate-menu-item" @click.stop="openPopup(3)">
                            <div class="icon-util delete operate-icon-position"></div>
                            <div class="operate-menu-name">{{$t('language.common.delete')}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="option-operate">
                <!-- 删除任务 -->
                <button class="white-button" @click.stop="openPopup(3)">{{$t('language.common.delete')}}</button>
            </div>
        </div>
        <div class="option-operate" v-else>
            <!-- 等待任务关闭 -->
            <button class="white-button" @click.stop="updateItem(0)">{{$t('language.common.cancel')}}</button>
        </div>
    </div>
</template>

<script>
export default {
    props: ['task'],
    computed: {
    },
    data: function() {
        return {
            isOpenMenu: false,//控制下拉框
            isRunning: false,
        }
    },
    watch: {
        isOpenMenu(newVal,oldVal) {
            if(newVal) {
            }
        }
    },
    methods: {
        //修改任务状态
        updateItem(type) {
            if(this.isRunning)return;
            /*  type参数:
                0: 停止任务
                1: 启动任务
             */
            //修改状态
            console.log(type)
            console.log(this.task)
            this.isRunning = true;
            var that = this;
            this.$emit("update",type,this.task,() => {
                that.isRunning = false;
            });
        },
        //打开对应功能弹出窗口
        openPopup(type) {
            /*  type参数:
                1: 日志详情窗口 viewLogsOpen
                2: 任务设置窗口 openOptionsDialog
                3: 删除任务窗口 deleteTaskItem
                4: 还原情况窗口 openBackupRestore
                5: 备份版本信息窗口 openVersions
                6: 任务进度信息窗口 openProgress
                7: 定时任务设置窗口 openSchduleDialog
                8: 多源或多目标信息窗口 openSourceList
             */
            //打开弹窗
            this.$emit("open-popup",type,this.task);
            //关闭菜单
            this.isOpenMenu = false;
        },
        //控制功能菜单状态
        changeOptionMenu(type,event) {
            this.isOpenMenu = type;
            if(type) {
                this.$nextTick(function () {
                    let menu = this.$refs.operateMenu;
                    if((event.clientX + 180) > document.body.offsetWidth) {
                        this.$refs.operateMenu.style.left = (event.target.offsetLeft - 165) +"px";
                    }else {
                        this.$refs.operateMenu.style.left = (event.target.offsetLeft + 15) +"px";
                    }
                    if(menu) {
                        let allHeight = document.body.offsetHeight;
                        let bottomedge = allHeight - event.clientY;
                        if (bottomedge < menu.offsetHeight) {
                            this.$refs.operateMenu.style.top = "auto";
                            this.$refs.operateMenu.style.bottom = "10px";
                        }
                    }
                });
            }
        },
    }
}
</script>

<style scoped>
.white-button {
    color: #000;
}
</style>


// WEBPACK FOOTER //
// src/components/common/tabs/tabs_task_list/tab_task_option.vue